/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-closing-bracket-location */
import DateFnsUtils from '@date-io/date-fns';
import Avatar from '@material-ui/core/Avatar';
import Checkbox from '@material-ui/core/Checkbox';
import CircularProgress from '@material-ui/core/CircularProgress';
import Container from '@material-ui/core/Container';
import CssBaseline from '@material-ui/core/CssBaseline';
import Fab from '@material-ui/core/Fab';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { keyBy, sortBy } from 'lodash';
import React, { Component } from 'react';
import { Trans, withTranslation } from 'react-i18next';
import Swal from 'sweetalert2';

import { formValidator, LogError } from '../../../AppUtil/AppUtil';
import BuxService from '../../../Service/BuxService';
import Session from '../../../Service/Session';
import UserService from '../../../Service/UserService';
import Loader from '../../Common/Loader';
import OtpScreen from './Otp';

import { Collapse, IconButton } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { Divider } from 'antd';
import { IIFC } from 'react-iifc';
import { useMediaQuery } from 'react-responsive';
import Barangays from '../../../Data/barangays.json';
import Municipalities from '../../../Data/municipalities.json';
import Provinces from '../../../Data/provinces.json';
import InputLabelMobile from '../../Common/Profile/InputLabelMobile';
import MobileFooter from '../../Common/Profile/MobileFooter';
import PageHeaderTitle from '../../Common/Profile/PageHeaderTitle';

import ExpandIcon from '../../Common/Profile/SvgIcon/ExpandIcon';

const ProvincesObj = keyBy(Provinces, 'description');
const MunicipalitiesObj = keyBy(Municipalities, 'description');
const { MOBILE } = window.AppConfig.SCREEN_SIZE;
const PATTERN = window.AppConfig.REGULAR_EXPRESSION;

const styles = theme => ({
	paper: {
		padding: theme.spacing(1),
		marginTop: theme.spacing(1),
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center'
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.main,
		textAlign: 'center'
	},
	form: {
		width: '100%'
	},
	submit: {
		margin: theme.spacing(3, 0, 2)
	},

	blockdiv: {
		textAlign: 'center'
	},
	displayFlex: {
		display: 'flex'
	},
	center: {
		textAlign: 'center'
	},
	uploadIdCss: {
		display: 'flex',
		color: 'red'
	},
	smallLabel: {
		fontSize: '12px !important',
		marginBottom: -15
	},
	previewImage: {
		marginBottom: 20
	}
});

class index extends Component {
	// NOSONAR

	constructor(props) {
		super(props);
		this.inputLabel = React.createRef();
		this.state = { isFocus: false };
		this.IdType = [
			{ label: 'SSS – Social Security System', value: 'SSS' },
			{
				label: 'GSIS eCard – Government Services and Insurance Corporation',
				value: 'GSIS'
			},
			{
				label: 'TIN',
				value: 'TIN'
			},
			{
				label: 'Driver’s License – Land Transportation Office',
				value: 'DRL'
			},
			{
				label: 'ACR - Alien Certificate of Registration',
				value: 'AICR'
			},
			{
				label: 'NBI',
				value: 'NBI'
			},
			{ label: 'Passport', value: 'PAS' },
			{ label: 'Philhealth ID', value: 'PHID' },
			{ label: 'School ID', value: 'SCH' },
			{ label: 'UMID', value: 'UMID' },
			{ label: 'Voters ID', value: 'VID' },
			{
				label: 'PRC ID - Philippine Regulatory Commission ID',
				value: 'PRC'
			},
			{
				label: 'Digitized Postal ID Philippine Postal Corporation',
				value: 'POS'
			}
		];
		this.civilStatus = [
			{ label: 'Single', value: 'S' },
			{ label: 'Married', value: 'M' },
			{ label: 'Widowed', value: 'W' },
			{ label: 'Divorced', value: 'D' }
		];
		this.sourceOfFunds = [
			{ label: 'Allowance', value: '001' },
			{ label: 'Business Profit', value: '002' },
			{ label: 'Commissions', value: '003' },
			{ label: 'Inheritance', value: '004' },
			{ label: 'Loan', value: '005' },
			{ label: 'Salary', value: '006' },
			{ label: 'Pension', value: '007' },
			{ label: 'Remittance', value: '008' }
		];
		this.employmentStatus = [
			{ label: 'Employed', value: 'EMP' },
			{ label: 'Consultant', value: 'CON' },
			{ label: 'Self-employed (Business)', value: 'SEB' },
			{ label: 'Self-employed (Freelancer)', value: 'SEF' },
			{ label: 'Unemployed (Housewife)', value: 'UEH' },
			{ label: 'Unemployed (Retired)', value: 'UER' },
			{ label: 'Unemployed (Student)', value: 'UES' }
		];
		this.employerIndustry = [
			{ label: 'Administrative/Human Resources', value: 'ADM' },
			{ label: 'Agriculture', value: 'AGRI' },
			{ label: 'Banking Institutions', value: 'BNK' },
			{
				label: 'Computer and Information Technology Services',
				value: 'IT'
			},
			{ label: 'Construction/Contractors', value: 'CONS' },
			{ label: 'Consultancy/Agencies', value: 'AGN' },
			{ label: 'Education', value: 'EDUC' },
			{ label: 'Engineering', value: 'ENG' },
			{ label: 'Entertainment', value: 'ENT' },
			{ label: 'Financial Services', value: 'FIN' },
			{ label: 'Government', value: 'FOV' },
			{ label: 'Hotel and Restaurant Services', value: 'HRS' },
			{ label: 'Household Employees', value: 'HSE' },
			{ label: 'Manufacturing and Inventory', value: 'INV' },
			{ label: 'Medical and Health Services', value: 'MED' },
			{ label: 'Community, Social, Personal Services', value: 'SOC' },
			{ label: 'Public Relations', value: 'PR' },
			{ label: 'Real Estate', value: 'EST' },
			{ label: 'Rental Services', value: 'RENT' },
			{ label: 'Sales/Marketing/Advertising', value: 'MKTG' },
			{ label: 'Science and Technology Services', value: 'SCI' },
			{
				label: 'Transportation and Communication Services',
				value: 'TCS'
			},
			{ label: 'Student', value: 'STD' },
			{ label: 'Others', value: 'OTH' }
		];

		const provinceId = this.props.currentUser.profile.province
			? ProvincesObj[this.props.currentUser.profile.province.toUpperCase()]
				? ProvincesObj[this.props.currentUser.profile.province.toUpperCase()].id
				: ''
			: '';
		const municipalityId = this.props.currentUser.profile.city
			? MunicipalitiesObj[this.props.currentUser.profile.city.toUpperCase()]
				? MunicipalitiesObj[this.props.currentUser.profile.city.toUpperCase()].id
				: ''
			: '';

		this.state = {
			isEnableEdit: false,
			provinces: sortBy(Provinces, 'description').map(d => ({
				label: d.description,
				value: d.description
			})),

			cities: provinceId
				? sortBy(
						Municipalities.filter(d => d.provinceId === provinceId),
						'description'
				  ).map(d => ({
						label: d.description,
						value: d.description
				  }))
				: [],
			barangays: municipalityId
				? sortBy(
						Barangays.filter(d => d.municipalityId === municipalityId),
						'description'
				  ).map(d => ({
						label: d.description,
						value: d.description
				  }))
				: [],

			_isMainLoading: false,
			_maxLength: '4',
			_openScreen: '',
			_statusRetry: false,
			_isDwollaProcessing: false,
			_agreeTermsAndConditions: false,
			_errorTermsAndConditionNotChecked: '',
			otpScreen: false,
			_DwollaSignUpForm: {
				firstName: {
					value: this.props.currentUser.profile.first_name,
					placeholder: 'First Name',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'First Name is Required'
						}
					},
					error_text: ''
				},
				middleName: {
					value: this.props.currentUser.profile.middle_name,
					placeholder: 'Middle Name',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'Middle Name is Required'
						}
					},
					error_text: ''
				},
				lastName: {
					value: this.props.currentUser.profile.last_name,
					placeholder: 'Last Name',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'Last Name is Required'
						}
					},
					error_text: ''
				},
				emailId: {
					value: this.props.currentUser.profile.email,
					placeholder: 'email',
					isValid: true,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'Valid Email Required'
						},
						pattern: {
							value: PATTERN.EMAIL,
							errorMsg: 'Valid Email Required'
						}
					},
					error_text: ''
				},
				idType: {
					value: this.props.currentUser.profile.id_type
						? JSON.parse(this.props.currentUser.profile.id_type)
						: {},
					placeholder: 'ID type',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'ID type is required'
						}
					},
					error_text: ''
				},
				idNumber: {
					value: this.props.currentUser.profile.id_number,
					placeholder: 'ID Number',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'ID Number is Required'
						}
					},
					error_text: ''
				},
				civilStatus: {
					value: this.props.currentUser.profile.civil_status
						? JSON.parse(this.props.currentUser.profile.civil_status)
						: {},
					placeholder: 'Civil Status',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'required_civil_status'
						}
					},
					error_text: ''
				},
				gender: {
					value: this.props.currentUser.profile.gender || 'M',
					placeholder: 'Gender',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'required_employment_status'
						}
					},
					error_text: ''
				},
				birthplace: {
					value: this.props.currentUser.profile.birth_place,
					placeholder: 'Birthplace',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'required_birthplace'
						}
					},
					error_text: ''
				},
				address: {
					value: this.props.currentUser.profile.address,
					placeholder: 'address',
					isValid: true,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'required_address'
						}
					},
					error_text: ''
				},
				province: {
					value: this.props.currentUser.profile.province
						? this.props.currentUser.profile.province.toUpperCase()
						: '',
					placeholder: 'Province',
					isValid: true,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'required_province'
						}
					},
					error_text: ''
				},
				city: {
					value: this.props.currentUser.profile.city ? this.props.currentUser.profile.city.toUpperCase() : '',
					placeholder: 'city',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'required_city'
						}
					},
					error_text: ''
				},
				barangay: {
					value: this.props.currentUser.profile.barangay
						? this.props.currentUser.profile.barangay.toUpperCase()
						: '',
					placeholder: 'Barangay',
					isValid: true,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'required_barangay'
						}
					},
					error_text: ''
				},
				dob: {
					value: this.props.currentUser.profile.dob
						? new Date(this.props.currentUser.profile.dob).valueOf()
						: null,
					placeholder: 'Date of Birth (MM/DD/YYYY)',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'required_dob'
						}
					},
					error_text: ''
				},
				postalCode: {
					value: this.props.currentUser.profile.postal_code,
					placeholder: 'postal_code',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'required_postal_code'
						},
						pattern: {
							value: PATTERN.ZIP,
							errorMsg: 'required_zip'
						}
					},
					error_text: ''
				},
				motherFirstName: {
					value: this.props.currentUser.profile.mother_first_name,
					placeholder: "Mother's Maiden First Name",
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'required_mother_first_name'
						}
					},
					error_text: ''
				},
				motherLastName: {
					value: this.props.currentUser.profile.mother_last_name,
					placeholder: "Mother's Maiden Last Name",
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'required_mother_last_name'
						}
					},
					error_text: ''
				},
				sourceOfFunds: {
					value: this.props.currentUser.profile.source_of_funds
						? JSON.parse(this.props.currentUser.profile.source_of_funds)
						: {},
					placeholder: 'Source of Funds',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'required_source_of_funds'
						}
					},
					error_text: ''
				},
				employmentStatus: {
					value: this.props.currentUser.profile.employment_status
						? JSON.parse(this.props.currentUser.profile.employment_status)
						: {},
					placeholder: 'Employment Status',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'required_employment_status'
						}
					},
					error_text: ''
				},
				employerName: {
					value: this.props.currentUser.profile.employer_name,
					placeholder: 'Employer Name',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'required_employer_name'
						}
					},
					error_text: ''
				},
				employerIndustry: {
					value: this.props.currentUser.profile.employment_industry
						? this.props.currentUser.profile.employment_industry
						: {},
					placeholder: 'Employer Industry',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'required_employer_industry'
						}
					},
					error_text: ''
				},
				employerStreet: {
					value: this.props.currentUser.profile.employer_street,
					placeholder: 'Employer Address Street',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'required_employer_street'
						}
					},
					error_text: ''
				},
				employerBarangay: {
					value: this.props.currentUser.profile.employer_barangay,
					placeholder: 'Employer Address Barangay',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'required_employer_barangay'
						}
					},
					error_text: ''
				},
				employerCity: {
					value: this.props.currentUser.profile.employer_city,
					placeholder: 'Employer Address City',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'required_employer_city'
						}
					},
					error_text: ''
				},
				employerProvince: {
					value: this.props.currentUser.profile.employer_province,
					placeholder: 'Employer Address Province',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'required_employer_province'
						}
					},
					error_text: ''
				},
				employerPostalCode: {
					value: this.props.currentUser.profile.employer_postal_code,
					placeholder: 'Employer Address Postal Code',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'required_employer_postal_code'
						}
					},
					error_text: ''
				}
			},
			_frontIdImage: {
				value: null,
				isValid: true,
				isThereImage: true,
				imageError: '',
				url: null,
				original: null
			},
			_backIdImage: {
				value: null,
				isValid: true,
				isThereImage: true,
				imageError: '',
				url: null,
				original: null
			},
			_selfieImage: {
				value: null,
				isValid: true,
				isThereImage: true,
				imageError: '',
				url: null,
				original: null
			}
		};
	}

	setLenderState = value => {
		for (let i = 0; i <= this.props.supportedStates.length; i++) {
			if (this.props.supportedStates[i].value === value) {
				return this.props.supportedStates[i];
			}
		}
	};

	handleTermsConditionChange = e => {
		this.setState({
			_errorTermsAndConditionNotChecked: '',
			_agreeTermsAndConditions: e.target.checked
		});
	};

	handleDropdownChange = (_event, value, name) => {
		const infoForm = {
			...this.state._DwollaSignUpForm,
			[name]: {
				...this.state._DwollaSignUpForm[name],
				value,
				isValid: true,
				error_text: ''
			}
		};

		if (name === 'employmentStatus' && (!value || (value && value.value !== 'EMP' && value.value !== 'CON'))) {
			return this.setState({
				_DwollaSignUpForm: {
					...infoForm,
					employerName: {
						...infoForm.employerName,
						value: '',
						isValid: true,
						error_text: ''
					},
					employerIndustry: {
						...infoForm.employerIndustry,
						value: {},
						isValid: true,
						error_text: ''
					},
					employerStreet: {
						...infoForm.employerStreet,
						value: '',
						isValid: true,
						error_text: ''
					},
					employerBarangay: {
						...infoForm.employerBarangay,
						value: '',
						isValid: true,
						error_text: ''
					},
					employerCity: {
						...infoForm.employerCity,
						value: '',
						isValid: true,
						error_text: ''
					},
					employerProvince: {
						...infoForm.employerProvince,
						value: '',
						isValid: true,
						error_text: ''
					},
					employerPostalCode: {
						...infoForm.employerPostalCode,
						value: '',
						isValid: true,
						error_text: ''
					}
				}
			});
		}

		if ((name === 'province' || name === 'employerProvince') && value) {
			const provinceId = ProvincesObj[value] ? ProvincesObj[value].id : '';
			this.setState({
				cities: provinceId
					? sortBy(
							Municipalities.filter(d => d.provinceId === provinceId),
							'description'
					  ).map(d => ({
							label: d.description,
							value: d.description
					  }))
					: []
			});
		}

		if ((name === 'city' || name === 'employerCity') && value) {
			const municipalityId = MunicipalitiesObj[value] ? MunicipalitiesObj[value].id : '';
			this.setState({
				barangays: municipalityId
					? sortBy(
							Barangays.filter(d => d.municipalityId === municipalityId),
							'description'
					  ).map(d => ({
							label: d.description,
							value: d.description
					  }))
					: []
			});
		}

		this.setState({
			_DwollaSignUpForm: infoForm
		});
	};

	handleStateChange = (_event, value) => {
		const infoForm = {
			...this.state._DwollaSignUpForm
		};
		const updatedFormElement = {
			...infoForm.state
		};
		updatedFormElement.value = value;
		updatedFormElement.isValid = true;
		updatedFormElement.error_text = '';
		infoForm.state = updatedFormElement;
		this.setState({
			_DwollaSignUpForm: infoForm
		});
	};

	handelInputChange = e => {
		const name = e.target.name;
		const value = e.target.value;
		const signUpForm = {
			...this.state._DwollaSignUpForm
		};
		const updatedFormElement = {
			...signUpForm[name]
		};
		updatedFormElement.value = value;
		updatedFormElement.isValid = true;
		updatedFormElement.error_text = '';
		signUpForm[name] = updatedFormElement;
		this.setState({
			_DwollaSignUpForm: signUpForm
		});
	};

	handleFileChange = async e => {
		const name = e.target.name;

		const file = e.target.files[0];
		const allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;

		if (allowedExtensions.test(file.name)) {
			await this.setState({
				[name]: {
					...this.state[name],
					value: e.target.files[0], //commented out due to error
					// selectedFile: e.target.files[0],
					isValid: true,
					isThereImage: true,
					url: URL.createObjectURL(e.target.files[0])
				}
			});
		}

		// if (file) {
		// 	const reader = new FileReader();
		// 	console.log(e.target.files[0]);

		// 	await this.setState({
		// 		[name]: {
		// 			...this.state[name],
		// 			value: e.target.files[0],
		// 			isValid: true,
		// 			isThereImage: true,
		// 			url: URL.createObjectURL(e.target.files[0])
		// 		}
		// 	});
		// }
		else {
			await this.setState({
				[name]: {
					...this.state[name],
					value: null,
					isValid: false,
					isThereImage: false
				}
			});
		}
		this.documentValidator(name);
	};

	documentValidator = imageName => {
		const image = this.state[imageName].value;
		const imageURL = this.state[imageName].url;

		this.setState({
			[imageName]: { ...this.state[imageName], imageError: '' }
		});

		let flag = true;

		if (imageURL) return flag;

		if (image) {
			if (image.size > 2 * 1024 * 1024) {
				this.setState({
					[imageName]: {
						...this.state[imageName],
						isValid: false,

						imageError: 'File is more than 2MB. Upload image file not more than 2MB' // changed from 10mb to 2mb as per design
					}
				});
				flag = false;
			} else if (!image.type.startsWith('image/')) {
				this.setState({
					[imageName]: {
						...this.state[imageName],
						isValid: false,
						imageError: 'Upload a valid image'
					}
				});
				flag = false;
			} else {
				this.setState({
					[imageName]: { ...this.state[imageName], isValid: true }
				});
			}
		} else {
			// if (!this.state[imageName].url) {
			flag = false;

			this.setState({
				[imageName]: {
					...this.state[imageName],
					isThereImage: false,
					isValid: false,
					imageError: 'Please upload a JPG or PNG file only'
				}
			});
			// }
		}

		return flag;
	};

	checkIfUserInRetryStatus = () => {
		const currentUser = this.props.currentUser.profile;
		return (
			this.state._statusRetry ||
			(currentUser.account !== null && currentUser.account.verification_status === 'retry')
		);
	};

	onRetryStatus = () => {
		const signUpForm = {
			...this.state._DwollaSignUpForm
		};
		signUpForm.firstName.value = '';
		signUpForm.lastName.value = '';
		signUpForm.address.value = '';
		signUpForm.city.value = '';
		signUpForm.state.value = '';
		signUpForm.postalCode.value = '';
		signUpForm.dob.value = new Date().setFullYear(new Date().getFullYear() - 18);
		signUpForm.ssn.value = '';
		signUpForm.ssn.placeholder = 'ssn_nine_digits';
		signUpForm.ssn.validationRules.pattern.value = PATTERN.SSN_NINE_DIGITS;
		signUpForm.ssn.validationRules.pattern.errorMsg = 'invalid_ssn_nine_digit';
		this.setState({
			_statusRetry: true,
			_DwollaSignUpForm: signUpForm,
			_agreeTermsAndConditions: false,
			_maxLength: '9'
		});
	};

	openDocumentScreen = () => {
		this.setState({
			_openScreen: 'DOCUMENT_VERIFICATION'
		});
	};

	openKbaScreen = () => {
		this.setState({
			_openScreen: 'KBA'
		});
	};

	closeDwollaScreen = () => {
		this.setState({
			_openScreen: ''
		});
		this.setScreenWhenBackToDwolla();
	};

	onSubmitHandler = async e => {
		e.preventDefault();

		Swal.fire({
			animation: false,
			allowOutsideClick: false,
			allowEscapeKey: false,
			showCancelButton: true,
			title: 'Are you sure you want to submit?',
			icon: 'success',
			customClass: 'otp_message_success',
			text: 'Please review your information before submitting.',
			imageAlt: 'Custom Image',
			// icon: 'error',
			confirmButtonText: 'Submit',

			customClass: 'otp_message_success'
		}).then(async result => {
			console.log(result);
			if (result.value) {
				if (!this.formValidator()) {
					return false;
				}

				try {
					Swal.showLoading();
					const response = await BuxService.getEmailAuthToken();
					await UserService.getKycStatus({ id: this.props.currentUser.profile.id, action: 'RESUBMIT_KYC' });
					if (response) {
						Session.store('EMAIL_AUTH_TOKEN', response.token);
						this.setState({
							otpScreen: true
						});
					} else {
						this.toastSomethingWentWrong();
					}
				} catch (err) {
					LogError(err);
					this.toastSomethingWentWrong();
				} finally {
					Swal.close(); // Close the SweetAlert
				}
			}
		});
	};

	handleDateChange = date => {
		const signUpForm = {
			...this.state._DwollaSignUpForm
		};
		const updatedFormElement = {
			...signUpForm.dob
		};
		updatedFormElement.value = date;
		updatedFormElement.isValid = true;
		signUpForm.dob = updatedFormElement;
		this.setState({
			_DwollaSignUpForm: signUpForm
		});
	};

	formValidator = () => {
		let flag = true;

		let form = {
			...this.state._DwollaSignUpForm
		};

		const employmentStatus = form.employmentStatus.value ? form.employmentStatus.value.value : null;

		form = {
			...form,
			employerName: {
				...form.employerName,
				validationRules: {
					...form.employerName.validationRules,
					isRequired: {
						...form.employerName.validationRules.isRequired,
						value: !!(employmentStatus === 'EMP' || employmentStatus === 'CON')
					}
				}
			},
			employerIndustry: {
				...form.employerIndustry,
				validationRules: {
					...form.employerIndustry.validationRules,
					isRequired: {
						...form.employerIndustry.validationRules.isRequired,
						value: !!(employmentStatus === 'EMP' || employmentStatus === 'CON')
					}
				}
			},
			employerStreet: {
				...form.employerStreet,
				validationRules: {
					...form.employerStreet.validationRules,
					isRequired: {
						...form.employerStreet.validationRules.isRequired,
						value: !!(employmentStatus === 'EMP' || employmentStatus === 'CON')
					}
				}
			},
			employerBarangay: {
				...form.employerBarangay,
				validationRules: {
					...form.employerBarangay.validationRules,
					isRequired: {
						...form.employerBarangay.validationRules.isRequired,
						value: !!(employmentStatus === 'EMP' || employmentStatus === 'CON')
					}
				}
			},
			employerCity: {
				...form.employerCity,
				validationRules: {
					...form.employerCity.validationRules,
					isRequired: {
						...form.employerCity.validationRules.isRequired,
						value: !!(employmentStatus === 'EMP' || employmentStatus === 'CON')
					}
				}
			},
			employerProvince: {
				...form.employerProvince,
				validationRules: {
					...form.employerProvince.validationRules,
					isRequired: {
						...form.employerProvince.validationRules.isRequired,
						value: !!(employmentStatus === 'EMP' || employmentStatus === 'CON')
					}
				}
			},
			employerPostalCode: {
				...form.employerPostalCode,
				validationRules: {
					...form.employerPostalCode.validationRules,
					isRequired: {
						...form.employerPostalCode.validationRules.isRequired,
						value: !!(employmentStatus === 'EMP' || employmentStatus === 'CON')
					}
				}
			}
		};

		const [updatedForm, isFormValid] = formValidator(form);

		// if (!this.state._isDateTouch) {
		// 	updatedForm.dob.isValid = false;
		// 	updatedForm.dob.error_text = "required_dob";
		// 	flag = false;
		// }

		if (updatedForm.idType.value && Object.keys(updatedForm.idType.value).length < 1) {
			updatedForm.idType.isValid = false;
			flag = false;
		}

		if (updatedForm.civilStatus.value && Object.keys(updatedForm.civilStatus.value).length < 1) {
			updatedForm.civilStatus.isValid = false;
			flag = false;
		}
		if (updatedForm.sourceOfFunds.value && Object.keys(updatedForm.sourceOfFunds.value).length < 1) {
			updatedForm.sourceOfFunds.isValid = false;
			flag = false;
		}

		if (
			!this.documentValidator('_frontIdImage') ||
			!this.documentValidator('_backIdImage') ||
			!this.documentValidator('_selfieImage')
		) {
			flag = false;
		}

		this.setState({
			_DwollaSignUpForm: updatedForm
		});

		return isFormValid && flag;
	};

	toastSomethingWentWrong = () => {
		Swal.fire({
			title: this.props.t('error'),
			text: this.props.t('something_went_wrong'),
			imageUrl: 'https://cdn-icons-png.flaticon.com/512/5219/5219070.png',
			imageAlt: 'Custom Image',
			// icon: 'error',
			confirmButtonText: this.props.t('try_again'),
			customClass: 'otp_message_success'
		});
	};

	dwollaProcessingStart = () => {
		this.setState({
			_isDwollaProcessing: true
		});
	};

	dwollaProcessingStop = () => {
		this.setState({
			_isDwollaProcessing: false
		});
	};

	termsConditionsLabel = () => {
		return (
			<Trans i18nKey="DwollaPlaid:terms_conditions_label">
				I agree that payments through LendAmi will be processed by the Bux wallet payment system.
			</Trans>
		);
	};

	setScreenWhenBackToDwolla = async () => {
		await this.setState({
			_isMainLoading: true
		});
		const currentUser = await UserService.updateCurrentUser();
		if (currentUser.profile) {
			await this.props.setCurrentUser(currentUser);
			await this.setState({
				_isMainLoading: false
			});
		}
		const account = currentUser.profile.account;
		if (!account) {
			return;
		}
		if (!account.verification) {
			return;
		}
		const stepRequired = account.verification.stepRequired;
		if (stepRequired === 'retry') {
			this.onRetryStatus();
		} else if (stepRequired === 'document') {
			this.openDocumentScreen();
		} else if (stepRequired === 'kba' || stepRequired === 'kba_initiated') {
			this.openKbaScreen();
		}
	};

	handleBackFromOtp = () => {
		this.setState({
			otpScreen: false
		});
	};

	oncloseOtp = async () => {
		const currentUser = await UserService.updateCurrentUser();
		if (currentUser.profile) {
			await this.props.setCurrentUser(currentUser);
		}
		await this.props.onBack();
	};

	async componentDidMount() {
		const uploadedIds = await UserService.signedUrlUploadId(this.props.currentUser.profile.id, {
			type: 'getObject'
		});
		const uploadedIdsObj = keyBy(uploadedIds.data.data, 'id');

		this.setState(data => ({
			_frontIdImage: {
				...data._frontIdImage,
				url: uploadedIdsObj.frontId ? uploadedIdsObj.frontId.url : null,
				original: uploadedIdsObj.frontId ? uploadedIdsObj.frontId.url : null
			},
			_backIdImage: {
				...data._backIdImage,
				url: uploadedIdsObj.backId ? uploadedIdsObj.backId.url : null,
				original: uploadedIdsObj.backId ? uploadedIdsObj.backId.url : null
			},
			_selfieImage: {
				...data._selfieImage,
				url: uploadedIdsObj.selfie ? uploadedIdsObj.selfie.url : null,
				original: uploadedIdsObj.selfie ? uploadedIdsObj.selfie.url : null
			}
		}));
	}

	handleFocus = () => {
		this.setState({ isFocus: true });
	};

	render() {
		// NOSONAR

		const { _DwollaSignUpForm } = this.state;
		const { classes } = this.props;
		const { t } = this.props;

		const employmentStatus = _DwollaSignUpForm.employmentStatus.value
			? _DwollaSignUpForm.employmentStatus.value.value
			: null;
		if (this.state._isMainLoading) {
			return <Loader />;
		} else if (this.state.otpScreen === true) {
			return (
				<OtpScreen
					forKYC={this.props.forKYC}
					currentUser={this.props.currentUser}
					dwollaSignUpForm={this.state._DwollaSignUpForm}
					formImages={[
						{ file: this.state._frontIdImage, id: 'frontId' },
						{ file: this.state._backIdImage, id: 'backId' },
						{ file: this.state._selfieImage, id: 'selfie' }
					]}
					handleBackFromOtp={this.handleBackFromOtp}
					oncloseOtp={this.oncloseOtp}
				/>
			);
		} else {
			return (
				<IIFC>
					{() => {
						const isMobile = useMediaQuery({ query: `(max-width: ${MOBILE})` });

						return (
							<Container component="main" className="kycform">
								<PageHeaderTitle
									className={isMobile ? 'kyc p-x-16' : null}
									isMobile={isMobile}
									onClick={this.props.onBack}
									subTitle='Please enter your correct details for validation. LendAmi conducts a risk-based "Know Your Customer" due diligence on all users. This process will include requiring a government issued ID to allow transactions within LendAmi.'
									title="Identity Verification"
								/>
								<CssBaseline />
								<Paper className={classes.paper}>
									<Grid container justify="center">
										<Grid item sm={8} xs={12}>
											<Paper className="no-shadow no-shadow-kyc">
												<div className={classes.paper}>
													{isMobile ? null : (
														<Avatar className={classes.avatar}>
															<LockOutlinedIcon />
														</Avatar>
													)}
													{isMobile ? null : this.state._statusRetry ? (
														<Typography
															className="text-center"
															component="h1"
															style={{
																fontSize: '25px',
																marginTop: '15px'
															}}
															variant="h5">
															{t('dwolla_heading_when_retry')}
														</Typography>
													) : (
														<Typography
															className="text-center main-top-heading"
															component="h1"
															variant="h5">
															{' '}
															{t('bux_kyc_main_heading')}
														</Typography>
													)}
													<form
														className={classes.form}
														noValidate
														onSubmit={this.onSubmitHandler}>
														<InputLabelMobile label="First Name*" />
														<TextField
															inputProps={{
																style: {
																	backgroundColor:
																		this.props.forKYC &&
																		!this.state.isEnableEdit &&
																		'lightgrey'
																}
															}}
															focused={this.props.forKYC && this.state.isEnableEdit}
															disabled={this.props.forKYC && !this.state.isEnableEdit}
															autoComplete="firstName"
															autoFocus
															className={classes.displayFlex}
															error={
																!this.state._DwollaSignUpForm.firstName.isValid &&
																this.state._DwollaSignUpForm.firstName.isTouched
															}
															fullWidth
															helperText={
																!this.state._DwollaSignUpForm.firstName.isValid &&
																this.state._DwollaSignUpForm.firstName.isTouched
																	? t(
																			this.state._DwollaSignUpForm.firstName
																				.error_text
																	  )
																	: ''
															}
															id="firstName"
															label={
																isMobile
																	? null
																	: t(
																			this.state._DwollaSignUpForm.firstName
																				.placeholder
																	  )
															}
															margin={isMobile ? 'none' : 'normal'}
															name="firstName"
															onChange={this.handelInputChange}
															placeholder={isMobile ? 'First Name' : null}
															value={this.state._DwollaSignUpForm.firstName.value}
															variant="outlined"
														/>
														<InputLabelMobile label="Middle Name*" />
														<TextField
															disabled={this.props.forKYC && !this.state.isEnableEdit}
															inputProps={{
																style: {
																	backgroundColor:
																		this.props.forKYC &&
																		!this.state.isEnableEdit &&
																		'lightgrey'
																}
															}}
															autoComplete="middleName"
															className={classes.displayFlex}
															error={
																!this.state._DwollaSignUpForm.middleName.isValid &&
																this.state._DwollaSignUpForm.middleName.isTouched
															}
															fullWidth
															helperText={
																!this.state._DwollaSignUpForm.middleName.isValid &&
																this.state._DwollaSignUpForm.middleName.isTouched
																	? t(
																			this.state._DwollaSignUpForm.middleName
																				.error_text
																	  )
																	: ''
															}
															id="middleName"
															label={
																isMobile
																	? null
																	: t(
																			this.state._DwollaSignUpForm.middleName
																				.placeholder
																	  )
															}
															margin={isMobile ? 'none' : 'normal'}
															name="middleName"
															onChange={this.handelInputChange}
															placeholder={isMobile ? 'Middle Name' : null}
															value={this.state._DwollaSignUpForm.middleName.value}
															variant="outlined"
														/>
														<InputLabelMobile label="Last Name*" />
														<TextField
															inputProps={{
																style: {
																	backgroundColor:
																		this.props.forKYC &&
																		!this.state.isEnableEdit &&
																		'lightgrey'
																}
															}}
															disabled={this.props.forKYC && !this.state.isEnableEdit}
															autoComplete="lastName"
															className={classes.displayFlex}
															error={
																!this.state._DwollaSignUpForm.lastName.isValid &&
																this.state._DwollaSignUpForm.lastName.isTouched
															}
															fullWidth
															helperText={
																!this.state._DwollaSignUpForm.lastName.isValid &&
																this.state._DwollaSignUpForm.lastName.isTouched
																	? t(
																			this.state._DwollaSignUpForm.lastName
																				.error_text
																	  )
																	: ''
															}
															id="lastName"
															label={
																isMobile
																	? null
																	: t(
																			this.state._DwollaSignUpForm.lastName
																				.placeholder
																	  )
															}
															margin={isMobile ? 'none' : 'normal'}
															name="lastName"
															onChange={this.handelInputChange}
															placeholder={isMobile ? 'Last Name' : null}
															value={this.state._DwollaSignUpForm.lastName.value}
															variant="outlined"
														/>
														<Divider className="mobile_divider kyc_mobile_divider" />
														<InputLabelMobile label="Email*" />
														<TextField
															inputProps={{
																style: {
																	backgroundColor: this.props.forKYC && 'lightgrey'
																}
															}}
															disabled={
																this.props.forKYC || // Condition 1
																(isMobile
																	? false
																	: !!this.props.currentUser.profile.email) // Condition 2
															}
															autoComplete="emailId"
															className={classes.displayFlex}
															error={
																!this.state._DwollaSignUpForm.emailId.isValid &&
																this.state._DwollaSignUpForm.emailId.isTouched
															}
															fullWidth
															helperText={
																!this.state._DwollaSignUpForm.emailId.isValid &&
																this.state._DwollaSignUpForm.emailId.isTouched
																	? t(this.state._DwollaSignUpForm.emailId.error_text)
																	: ''
															}
															label={
																isMobile
																	? null
																	: t(
																			this.state._DwollaSignUpForm.emailId
																				.placeholder
																	  )
															}
															margin={isMobile ? 'none' : 'normal'}
															name="emailId"
															onBlur={() => this.setState({ isFocus: false })}
															onChange={this.handelInputChange}
															onFocus={this.handleFocus}
															placeholder={isMobile ? 'Email' : null}
															value={this.state._DwollaSignUpForm.emailId.value}
															variant="outlined"
														/>

														<Collapse in={this.state.isFocus}>
															<Alert
																action={
																	<IconButton
																		aria-label="close"
																		color="inherit"
																		onClick={() => {
																			this.setState({ isFocus: false });
																		}}
																		size="small"
																	/>
																}
																severity="warning">
																Kindly be advised that once your wallet has been
																created, you will no longer be able to change the mobile
																number and email address associated to this account.
																Please ensure you enter the correct primary information.
															</Alert>
														</Collapse>

														<Divider className="mobile_divider kyc_mobile_divider" />

														<p className={isMobile ? 'identification' : ''}>
															Identification{' '}
															{isMobile ? null : (
																<span style={{ fontSize: '14px' }}>*</span>
															)}
														</p>
														<InputLabelMobile label="ID Type*" />
														<Autocomplete
															style={{
																backgroundColor:
																	this.props.forKYC &&
																	!this.state.isEnableEdit &&
																	'lightgrey'
															}}
															disabled={this.props.forKYC && !this.state.isEnableEdit}
															fullwidth
															getOptionLabel={option => option.label || ''}
															id="idType"
															name="idType"
															onChange={(event, value) =>
																this.handleDropdownChange(event, value, 'idType')
															}
															options={this.IdType}
															popupIcon={<ExpandIcon />}
															renderInput={params => (
																<TextField
																	{...params}
																	error={
																		!this.state._DwollaSignUpForm.idType.isValid &&
																		this.state._DwollaSignUpForm.idType.isTouched
																	}
																	label={
																		isMobile
																			? null
																			: t(
																					this.state._DwollaSignUpForm.idType
																						.placeholder
																			  )
																	}
																	name="region"
																	placeholder="ID Type"
																	variant="outlined"
																/>
															)}
															value={this.state._DwollaSignUpForm.idType.value}
														/>
														{!this.state._DwollaSignUpForm.idType.isValid &&
														this.state._DwollaSignUpForm.idType.isTouched ? (
															<FormHelperText
																id="text-red"
																style={{
																	margin: '-10px 15px 10px'
																}}>
																{t(this.state._DwollaSignUpForm.idType.error_text)}
															</FormHelperText>
														) : (
															''
														)}
														<InputLabelMobile label="ID Number*" />
														<TextField
															inputProps={{
																style: {
																	backgroundColor:
																		this.props.forKYC &&
																		!this.state.isEnableEdit &&
																		'lightgrey'
																}
															}}
															disabled={this.props.forKYC && !this.state.isEnableEdit}
															autoComplete="idNumber"
															className={classes.displayFlex}
															error={
																!this.state._DwollaSignUpForm.idNumber.isValid &&
																this.state._DwollaSignUpForm.idNumber.isTouched
															}
															fullWidth
															helperText={
																!this.state._DwollaSignUpForm.idNumber.isValid &&
																this.state._DwollaSignUpForm.idNumber.isTouched
																	? t(
																			this.state._DwollaSignUpForm.idNumber
																				.error_text
																	  )
																	: ''
															}
															id="idNumber"
															label={
																isMobile
																	? null
																	: t(
																			this.state._DwollaSignUpForm.idNumber
																				.placeholder
																	  )
															}
															name="idNumber"
															onChange={this.handelInputChange}
															placeholder={isMobile ? 'ID Number' : null}
															required
															value={this.state._DwollaSignUpForm.idNumber.value}
															variant="outlined"
														/>

														{isMobile ? null : (
															<p className={classes.smallLabel}>
																Upload Front ID Image{' '}
																<span style={{ fontSize: '14px' }}>*</span>{' '}
															</p>
														)}
														<InputLabelMobile label="Upload Front ID Image* (Maximum file size: 2MB)" />

														<TextField
															inputProps={{
																style: {
																	backgroundColor:
																		this.props.forKYC &&
																		!this.state.isEnableEdit &&
																		'lightgrey'
																}
															}}
															disabled={this.props.forKYC && !this.state.isEnableEdit}
															className={classes.uploadIdCss}
															error={
																!this.state._frontIdImage.isValid ||
																!this.state._frontIdImage.isThereImage
															}
															errorMsg={this.state._frontIdImage.imageError}
															fullWidth
															helperText={
																!this.state._frontIdImage.isValid
																	? this.state._frontIdImage.imageError
																	: ''
															}
															id="_frontIdImage"
															margin={isMobile ? 'none' : 'normal'}
															name="_frontIdImage"
															onChange={e => this.handleFileChange(e)}
															required
															type="file"
															variant="outlined"
														/>
														{!this.state._frontIdImage.isValid &&
														this.state._frontIdImage.original ? (
															<img
																className={classes.previewImage}
																height={150}
																src={this.state._frontIdImage.original}
																width="auto"
															/>
														) : (
															<img
																className={classes.previewImage}
																height={150}
																src={this.state._frontIdImage.url}
																width="auto"
															/>
														)}

														{isMobile ? null : (
															<p className={classes.smallLabel}>
																Upload Back ID Image{' '}
																<span style={{ fontSize: '14px' }}>*</span>{' '}
															</p>
														)}
														<InputLabelMobile label="Upload Back ID Image* (Maximum file size: 2MB)" />
														<TextField
															inputProps={{
																style: {
																	backgroundColor:
																		this.props.forKYC &&
																		!this.state.isEnableEdit &&
																		'lightgrey'
																}
															}}
															disabled={this.props.forKYC && !this.state.isEnableEdit}
															className={classes.uploadIdCss}
															error={
																!this.state._backIdImage.isValid ||
																!this.state._backIdImage.isThereImage
															}
															errorMsg={this.state._backIdImage.imageError}
															fullWidth
															helperText={
																!this.state._backIdImage.isValid
																	? this.state._backIdImage.imageError
																	: ''
															}
															id="_backIdImage"
															margin={isMobile ? 'none' : 'normal'}
															name="_backIdImage"
															onChange={e => this.handleFileChange(e)}
															required
															type="file"
															variant="outlined"
														/>

														{!this.state._backIdImage.isValid &&
														this.state._backIdImage.url ? (
															<img
																className={classes.previewImage}
																height={150}
																src={this.state._backIdImage.original}
																width="auto"
															/>
														) : (
															<img
																className={classes.previewImage}
																height={150}
																src={this.state._backIdImage.url}
																width="auto"
															/>
														)}

														{isMobile ? null : (
															<p className={classes.smallLabel}>
																Upload Selfie Image{' '}
																<span style={{ fontSize: '14px' }}>*</span>{' '}
															</p>
														)}
														<InputLabelMobile label="Upload Selfie Image* (Maximum file size: 2MB)" />
														<TextField
															inputProps={{
																style: {
																	backgroundColor:
																		this.props.forKYC &&
																		!this.state.isEnableEdit &&
																		'lightgrey'
																}
															}}
															disabled={this.props.forKYC && !this.state.isEnableEdit}
															className={classes.uploadIdCss}
															error={
																!this.state._selfieImage.isValid ||
																!this.state._selfieImage.isThereImage
															}
															errorMsg={this.state._selfieImage.imageError}
															fullWidth
															helperText={
																!this.state._selfieImage.isValid
																	? this.state._selfieImage.imageError
																	: ''
															}
															id="_selfieImage"
															margin={isMobile ? 'none' : 'normal'}
															name="_selfieImage"
															onChange={e => this.handleFileChange(e)}
															required
															type="file"
															variant="outlined"
														/>
														{!this.state._selfieImage.isValid &&
														this.state._selfieImage.url ? (
															<img
																className={classes.previewImage}
																height={150}
																src={this.state._selfieImage.original}
																width="auto"
															/>
														) : (
															<img
																className={classes.previewImage}
																height={150}
																src={this.state._selfieImage.url}
																width="auto"
															/>
														)}
														<Divider className="mobile_divider kyc_mobile_divider" />
														<InputLabelMobile label="Civil Status*" />
														<Autocomplete
															style={{
																backgroundColor:
																	this.props.forKYC &&
																	!this.state.isEnableEdit &&
																	'lightgrey'
															}}
															disabled={this.props.forKYC && !this.state.isEnableEdit}
															fullwidth
															getOptionLabel={option => option.label || ''}
															id="civilStatus"
															name="civilStatus"
															onChange={(event, value) =>
																this.handleDropdownChange(event, value, 'civilStatus')
															}
															options={this.civilStatus}
															popupIcon={<ExpandIcon />}
															renderInput={params => (
																<TextField
																	disabled={
																		this.props.forKYC && !this.state.isEnableEdit
																	}
																	{...params}
																	error={
																		!this.state._DwollaSignUpForm.civilStatus
																			.isValid &&
																		this.state._DwollaSignUpForm.civilStatus
																			.isTouched
																	}
																	label={
																		isMobile
																			? null
																			: t(
																					this.state._DwollaSignUpForm
																						.civilStatus.placeholder
																			  )
																	}
																	name="region"
																	placeholder={isMobile ? 'Civil Status' : null}
																	variant="outlined"
																/>
															)}
															value={this.state._DwollaSignUpForm.civilStatus.value}
														/>
														{!this.state._DwollaSignUpForm.civilStatus.isValid &&
														this.state._DwollaSignUpForm.civilStatus.isTouched ? (
															<FormHelperText
																id="text-red"
																style={{
																	margin: '-10px 15px 10px'
																}}>
																{t(this.state._DwollaSignUpForm.civilStatus.error_text)}
															</FormHelperText>
														) : (
															''
														)}
														<InputLabelMobile label="Gender*" />
														<FormControl>
															{isMobile ? null : (
																<FormLabel id="gender">
																	{t(this.state._DwollaSignUpForm.gender.placeholder)}
																</FormLabel>
															)}
															<RadioGroup
																className="gender"
																defaultValue={this.state._DwollaSignUpForm.gender.value}
																name="gender"
																onChange={this.handelInputChange}
																value={this.state._DwollaSignUpForm.gender.value}>
																<FormControlLabel
																	disabled={
																		this.props.forKYC && !this.state.isEnableEdit
																	}
																	control={<Radio />}
																	label="Male"
																	value="M"
																/>
																<FormControlLabel
																	disabled={
																		this.props.forKYC && !this.state.isEnableEdit
																	}
																	control={<Radio />}
																	label="Female"
																	value="F"
																/>
															</RadioGroup>
														</FormControl>
														<InputLabelMobile label="Birthplace*" />
														<TextField
															inputProps={{
																style: {
																	backgroundColor:
																		this.props.forKYC &&
																		!this.state.isEnableEdit &&
																		'lightgrey'
																}
															}}
															disabled={this.props.forKYC && !this.state.isEnableEdit}
															autoComplete="birthplace"
															className={classes.displayFlex}
															error={
																!this.state._DwollaSignUpForm.birthplace.isValid &&
																this.state._DwollaSignUpForm.birthplace.isTouched
															}
															fullWidth
															helperText={
																!this.state._DwollaSignUpForm.birthplace.isValid &&
																this.state._DwollaSignUpForm.birthplace.isTouched
																	? t(
																			this.state._DwollaSignUpForm.birthplace
																				.error_text
																	  )
																	: ''
															}
															id="birthplace"
															label={
																isMobile
																	? null
																	: t(
																			this.state._DwollaSignUpForm.birthplace
																				.placeholder
																	  )
															}
															margin={isMobile ? 'none' : 'normal'}
															name="birthplace"
															onChange={this.handelInputChange}
															placeholder={isMobile ? 'Birthplace' : null}
															required
															value={this.state._DwollaSignUpForm.birthplace.value}
															variant="outlined"
														/>
														<InputLabelMobile label="Date of Birth*" />
														<form
															className="text-center"
															onSubmit={e => {
																e.preventDefault();
															}}>
															<MuiPickersUtilsProvider utils={DateFnsUtils}>
																<KeyboardDatePicker
																	inputProps={{
																		style: {
																			backgroundColor:
																				this.props.forKYC &&
																				!this.state.isEnableEdit &&
																				'lightgrey'
																		}
																	}}
																	disabled={
																		this.props.forKYC && !this.state.isEnableEdit
																	}
																	autoOk
																	error={
																		!this.state._DwollaSignUpForm.dob.isValid &&
																		this.state._DwollaSignUpForm.dob.isTouched
																	}
																	format="MM/dd/yyyy"
																	fullWidth
																	id={
																		this.state.disabled
																			? 'date-picker-dialog'
																			: null
																	}
																	inputVariant="outlined"
																	KeyboardButtonProps={{
																		'aria-label': 'change date'
																	}}
																	label={
																		isMobile
																			? null
																			: t(
																					this.state._DwollaSignUpForm.dob
																						.placeholder
																			  )
																	}
																	maxDate={new Date().setFullYear(
																		new Date().getFullYear() - 18
																	)}
																	maxDateMessage={t('max_date_error')}
																	name="dob"
																	onChange={this.handleDateChange}
																	onFocus={this.onFocus}
																	placeholder={isMobile ? 'MM/DD/YYYY' : null}
																	value={this.state._DwollaSignUpForm.dob.value}
																/>
																{!this.state._DwollaSignUpForm.dob.isValid &&
																this.state._DwollaSignUpForm.dob.isTouched ? (
																	<FormHelperText
																		id="text-red"
																		style={{
																			margin: '-10px 15px 10px'
																		}}>
																		{t(this.state._DwollaSignUpForm.dob.error_text)}
																	</FormHelperText>
																) : (
																	''
																)}
															</MuiPickersUtilsProvider>
														</form>
														<Divider className="mobile_divider kyc_mobile_divider" />
														<InputLabelMobile label="Address*" />
														<TextField
															InputProps={{
																style: {
																	backgroundColor:
																		this.props.forKYC &&
																		!this.state.isEnableEdit &&
																		'lightgrey'
																}
															}}
															disabled={this.props.forKYC && !this.state.isEnableEdit}
															autoComplete="address"
															className={classes.displayFlex}
															error={
																!this.state._DwollaSignUpForm.address.isValid &&
																this.state._DwollaSignUpForm.address.isTouched
															}
															fullWidth
															helperText={
																!this.state._DwollaSignUpForm.address.isValid &&
																this.state._DwollaSignUpForm.address.isTouched
																	? t(this.state._DwollaSignUpForm.address.error_text)
																	: ''
															}
															id="address"
															inputProps={{ maxLength: 50 }}
															label={
																isMobile
																	? null
																	: t(
																			this.state._DwollaSignUpForm.address
																				.placeholder
																	  )
															}
															multiline
															name="address"
															onChange={this.handelInputChange}
															placeholder={isMobile ? 'Address Line 1' : null}
															required
															rows="4"
															value={this.state._DwollaSignUpForm.address.value}
															variant="outlined"
														/>
														<InputLabelMobile label="Province*" />
														<Autocomplete
															style={{
																backgroundColor:
																	this.props.forKYC &&
																	!this.state.isEnableEdit &&
																	'lightgrey'
															}}
															disabled={this.props.forKYC && !this.state.isEnableEdit}
															fullwidth
															getOptionLabel={option => option.label || ''}
															id="province"
															name="province"
															onChange={(event, value) => {
																this.handleDropdownChange(
																	event,
																	value ? value.value : '',
																	'province'
																);
															}}
															options={this.state.provinces}
															popupIcon={<ExpandIcon />}
															renderInput={params => (
																<TextField
																	disabled={
																		this.props.forKYC && !this.state.isEnableEdit
																	}
																	{...params}
																	autoComplete="off"
																	error={
																		!this.state._DwollaSignUpForm.province
																			.isValid &&
																		this.state._DwollaSignUpForm.province.isTouched
																	}
																	label={
																		isMobile
																			? null
																			: t(
																					this.state._DwollaSignUpForm
																						.province.placeholder
																			  )
																	}
																	name="region"
																	placeholder={isMobile ? 'Province' : null}
																	variant="outlined"
																/>
															)}
															value={{
																label: this.state._DwollaSignUpForm.province.value,
																value: this.state._DwollaSignUpForm.province.value
															}}
														/>
														<InputLabelMobile label="City*" />
														<Autocomplete
															style={{
																backgroundColor:
																	this.props.forKYC &&
																	!this.state.isEnableEdit &&
																	'lightgrey'
															}}
															disabled={this.props.forKYC && !this.state.isEnableEdit}
															fullwidth
															getOptionLabel={option => option.label || ''}
															id="city"
															name="city"
															onChange={(event, value) =>
																this.handleDropdownChange(
																	event,
																	value ? value.value : '',
																	'city'
																)
															}
															options={this.state.cities}
															popupIcon={<ExpandIcon />}
															renderInput={params => (
																<TextField
																	disabled={
																		this.props.forKYC && !this.state.isEnableEdit
																	}
																	{...params}
																	autoComplete="off"
																	error={
																		!this.state._DwollaSignUpForm.city.isValid &&
																		this.state._DwollaSignUpForm.city.isTouched
																	}
																	label={
																		isMobile
																			? null
																			: t(
																					this.state._DwollaSignUpForm.city
																						.placeholder
																			  )
																	}
																	name="region"
																	placeholder={isMobile ? 'City' : null}
																	variant="outlined"
																/>
															)}
															value={{
																label: this.state._DwollaSignUpForm.city.value,
																value: this.state._DwollaSignUpForm.city.value
															}}
														/>
														<InputLabelMobile label="Barangay*" />
														<Autocomplete
															style={{
																backgroundColor:
																	this.props.forKYC &&
																	!this.state.isEnableEdit &&
																	'lightgrey'
															}}
															disabled={this.props.forKYC && !this.state.isEnableEdit}
															fullwidth
															getOptionLabel={option => option.label || ''}
															id="barangay"
															name="barangay"
															onChange={(event, value) =>
																this.handleDropdownChange(
																	event,
																	value ? value.value : '',
																	'barangay'
																)
															}
															options={this.state.barangays}
															popupIcon={<ExpandIcon />}
															renderInput={params => (
																<TextField
																	disabled={
																		this.props.forKYC && !this.state.isEnableEdit
																	}
																	{...params}
																	autoComplete="off"
																	error={
																		!this.state._DwollaSignUpForm.barangay
																			.isValid &&
																		this.state._DwollaSignUpForm.barangay.isTouched
																	}
																	label={
																		isMobile
																			? null
																			: t(
																					this.state._DwollaSignUpForm
																						.barangay.placeholder
																			  )
																	}
																	name="region"
																	placeholder={isMobile ? 'Barangay' : null}
																	variant="outlined"
																/>
															)}
															value={{
																label: this.state._DwollaSignUpForm.barangay.value,
																value: this.state._DwollaSignUpForm.barangay.value
															}}
														/>
														<InputLabelMobile label="Postal Code*" />
														<TextField
															inputProps={{
																style: {
																	backgroundColor:
																		this.props.forKYC &&
																		!this.state.isEnableEdit &&
																		'lightgrey'
																}
															}}
															disabled={this.props.forKYC && !this.state.isEnableEdit}
															autoComplete="postalCode"
															className={classes.displayFlex}
															error={
																!this.state._DwollaSignUpForm.postalCode.isValid &&
																this.state._DwollaSignUpForm.postalCode.isTouched
															}
															fullWidth
															helperText={
																!this.state._DwollaSignUpForm.postalCode.isValid &&
																this.state._DwollaSignUpForm.postalCode.isTouched
																	? t(
																			this.state._DwollaSignUpForm.postalCode
																				.error_text
																	  )
																	: ''
															}
															id="postalCode"
															label={
																isMobile
																	? null
																	: t(
																			this.state._DwollaSignUpForm.postalCode
																				.placeholder
																	  )
															}
															name="postalCode"
															onChange={this.handelInputChange}
															placeholder={isMobile ? 'Postal Code' : null}
															required
															value={this.state._DwollaSignUpForm.postalCode.value}
															variant="outlined"
														/>

														<Divider className="mobile_divider kyc_mobile_divider" />
														<InputLabelMobile label="Mother's Maiden First Name*" />
														<TextField
															inputProps={{
																style: {
																	backgroundColor:
																		this.props.forKYC &&
																		!this.state.isEnableEdit &&
																		'lightgrey'
																}
															}}
															disabled={this.props.forKYC && !this.state.isEnableEdit}
															autoComplete="motherFirstName"
															className={classes.displayFlex}
															error={
																!this.state._DwollaSignUpForm.motherFirstName.isValid &&
																this.state._DwollaSignUpForm.motherFirstName.isTouched
															}
															fullWidth
															helperText={
																!this.state._DwollaSignUpForm.motherFirstName.isValid &&
																this.state._DwollaSignUpForm.motherFirstName.isTouched
																	? t(
																			this.state._DwollaSignUpForm.motherFirstName
																				.error_text
																	  )
																	: ''
															}
															id="motherFirstName"
															label={
																isMobile
																	? null
																	: t(
																			this.state._DwollaSignUpForm.motherFirstName
																				.placeholder
																	  )
															}
															margin={isMobile ? 'none' : 'normal'}
															name="motherFirstName"
															onChange={this.handelInputChange}
															placeholder={isMobile ? "Mother's Maiden First Name" : null}
															required
															value={this.state._DwollaSignUpForm.motherFirstName.value}
															variant="outlined"
														/>
														<InputLabelMobile label="Mother's Maiden Last Name*" />
														<TextField
															inputProps={{
																style: {
																	backgroundColor:
																		this.props.forKYC &&
																		!this.state.isEnableEdit &&
																		'lightgrey'
																}
															}}
															disabled={this.props.forKYC && !this.state.isEnableEdit}
															autoComplete="motherLastName"
															className={classes.displayFlex}
															error={
																!this.state._DwollaSignUpForm.motherLastName.isValid &&
																this.state._DwollaSignUpForm.motherLastName.isTouched
															}
															fullWidth
															helperText={
																!this.state._DwollaSignUpForm.motherLastName.isValid &&
																this.state._DwollaSignUpForm.motherLastName.isTouched
																	? t(
																			this.state._DwollaSignUpForm.motherLastName
																				.error_text
																	  )
																	: ''
															}
															id="motherLastName"
															label={
																isMobile
																	? null
																	: t(
																			this.state._DwollaSignUpForm.motherLastName
																				.placeholder
																	  )
															}
															margin={isMobile ? 'none' : 'normal'}
															name="motherLastName"
															onChange={this.handelInputChange}
															placeholder={isMobile ? "Mother's Maiden Last Name" : null}
															required
															value={this.state._DwollaSignUpForm.motherLastName.value}
															variant="outlined"
														/>
														<InputLabelMobile label="Source of Funds*" />
														<Autocomplete
															style={{
																backgroundColor:
																	this.props.forKYC &&
																	!this.state.isEnableEdit &&
																	'lightgrey'
															}}
															disabled={this.props.forKYC && !this.state.isEnableEdit}
															fullwidth
															getOptionLabel={option => option.label || ''}
															id="sourceOfFunds"
															name="sourceOfFunds"
															onChange={(event, value) =>
																this.handleDropdownChange(event, value, 'sourceOfFunds')
															}
															options={this.sourceOfFunds}
															popupIcon={<ExpandIcon />}
															renderInput={params => (
																<TextField
																	disabled={
																		this.props.forKYC && !this.state.isEnableEdit
																	}
																	{...params}
																	error={
																		!this.state._DwollaSignUpForm.sourceOfFunds
																			.isValid &&
																		this.state._DwollaSignUpForm.sourceOfFunds
																			.isTouched
																	}
																	label={
																		isMobile
																			? null
																			: t(
																					this.state._DwollaSignUpForm
																						.sourceOfFunds.placeholder
																			  )
																	}
																	name="region"
																	placeholder={isMobile ? 'Source of Funds' : null}
																	variant="outlined"
																/>
															)}
															value={this.state._DwollaSignUpForm.sourceOfFunds.value}
														/>
														{!this.state._DwollaSignUpForm.sourceOfFunds.isValid &&
														this.state._DwollaSignUpForm.sourceOfFunds.isTouched ? (
															<FormHelperText
																id="text-red"
																style={{
																	margin: '-10px 15px 10px'
																}}>
																{t(
																	this.state._DwollaSignUpForm.sourceOfFunds
																		.error_text
																)}
															</FormHelperText>
														) : (
															''
														)}
														<InputLabelMobile label="Employment Status*" />
														<Autocomplete
															style={{
																backgroundColor:
																	this.props.forKYC &&
																	!this.state.isEnableEdit &&
																	'lightgrey'
															}}
															disabled={this.props.forKYC && !this.state.isEnableEdit}
															fullwidth
															getOptionLabel={option => option.label || ''}
															id="employmentStatus"
															name="employmentStatus"
															onChange={(event, value) =>
																this.handleDropdownChange(
																	event,
																	value,
																	'employmentStatus'
																)
															}
															options={this.employmentStatus}
															popupIcon={<ExpandIcon />}
															renderInput={params => (
																<TextField
																	disabled={
																		this.props.forKYC && !this.state.isEnableEdit
																	}
																	{...params}
																	error={
																		!this.state._DwollaSignUpForm.employmentStatus
																			.isValid &&
																		this.state._DwollaSignUpForm.employmentStatus
																			.isTouched
																	}
																	label={
																		isMobile
																			? null
																			: t(
																					this.state._DwollaSignUpForm
																						.employmentStatus.placeholder
																			  )
																	}
																	name="region"
																	placeholder={isMobile ? 'Employment Status' : null}
																	variant="outlined"
																/>
															)}
															value={this.state._DwollaSignUpForm.employmentStatus.value}
														/>
														{!this.state._DwollaSignUpForm.employmentStatus.isValid &&
														this.state._DwollaSignUpForm.employmentStatus.isTouched ? (
															<FormHelperText
																id="text-red"
																style={{
																	margin: '-10px 15px 10px'
																}}>
																{t(
																	this.state._DwollaSignUpForm.employmentStatus
																		.error_text
																)}
															</FormHelperText>
														) : (
															''
														)}

														{(employmentStatus === 'EMP' || employmentStatus === 'CON') && (
															<TextField
																inputProps={{
																	style: {
																		backgroundColor:
																			this.props.forKYC &&
																			!this.state.isEnableEdit &&
																			'lightgrey'
																	}
																}}
																disabled={this.props.forKYC && !this.state.isEnableEdit}
																autoComplete="employerName"
																className={classes.displayFlex}
																error={
																	!this.state._DwollaSignUpForm.employerName
																		.isValid &&
																	this.state._DwollaSignUpForm.employerName.isTouched
																}
																fullWidth
																helperText={
																	!this.state._DwollaSignUpForm.employerName
																		.isValid &&
																	this.state._DwollaSignUpForm.employerName.isTouched
																		? t(
																				this.state._DwollaSignUpForm
																					.employerName.error_text
																		  )
																		: ''
																}
																id="employerName"
																label={
																	isMobile
																		? null
																		: t(
																				this.state._DwollaSignUpForm
																					.employerName.placeholder
																		  )
																}
																margin={isMobile ? 'none' : 'normal'}
																name="employerName"
																onChange={this.handelInputChange}
																placeholder={isMobile ? 'Employer Name' : null}
																value={this.state._DwollaSignUpForm.employerName.value}
																variant="outlined"
															/>
														)}

														{(employmentStatus === 'EMP' || employmentStatus === 'CON') && (
															<Autocomplete
																style={{
																	backgroundColor:
																		this.props.forKYC &&
																		!this.state.isEnableEdit &&
																		'lightgrey'
																}}
																disabled={this.props.forKYC && !this.state.isEnableEdit}
																fullwidth
																getOptionLabel={option => option.label || ''}
																id="employerIndustry"
																name="employerIndustry"
																onChange={(event, value) =>
																	this.handleDropdownChange(
																		event,
																		value,
																		'employerIndustry'
																	)
																}
																options={this.employerIndustry}
																popupIcon={<ExpandIcon />}
																renderInput={params => (
																	<TextField
																		disabled={
																			this.props.forKYC &&
																			!this.state.isEnableEdit
																		}
																		{...params}
																		error={
																			!this.state._DwollaSignUpForm
																				.employerIndustry.isValid &&
																			this.state._DwollaSignUpForm
																				.employerIndustry.isTouched
																		}
																		label={
																			isMobile
																				? null
																				: t(
																						this.state._DwollaSignUpForm
																							.employerIndustry
																							.placeholder
																				  )
																		}
																		name="employerIndustry"
																		placeholder={
																			isMobile ? 'Employer Industry' : null
																		}
																		variant="outlined"
																	/>
																)}
																value={
																	this.state._DwollaSignUpForm.employerIndustry.value
																}
															/>
														)}
														{!this.state._DwollaSignUpForm.employerIndustry.isValid &&
														this.state._DwollaSignUpForm.employerIndustry.isTouched ? (
															<FormHelperText
																id="text-red"
																style={{
																	margin: '-10px 15px 10px'
																}}>
																{t(
																	this.state._DwollaSignUpForm.employerIndustry
																		.error_text
																)}
															</FormHelperText>
														) : (
															''
														)}

														{(employmentStatus === 'EMP' || employmentStatus === 'CON') && (
															<p>
																Employer Address{' '}
																<span
																	style={{
																		fontSize: '14px'
																	}}>
																	*
																</span>{' '}
															</p>
														)}
														{(employmentStatus === 'EMP' || employmentStatus === 'CON') && (
															<TextField
																inputProps={{
																	style: {
																		backgroundColor:
																			this.props.forKYC &&
																			!this.state.isEnableEdit &&
																			'lightgrey'
																	}
																}}
																disabled={this.props.forKYC && !this.state.isEnableEdit}
																autoComplete="employerStreet"
																className={classes.displayFlex}
																error={
																	!this.state._DwollaSignUpForm.employerStreet
																		.isValid &&
																	this.state._DwollaSignUpForm.employerStreet
																		.isTouched
																}
																fullWidth
																helperText={
																	!this.state._DwollaSignUpForm.employerStreet
																		.isValid &&
																	this.state._DwollaSignUpForm.employerStreet
																		.isTouched
																		? t(
																				this.state._DwollaSignUpForm
																					.employerStreet.error_text
																		  )
																		: ''
																}
																id="employerStreet"
																label={
																	isMobile
																		? null
																		: t(
																				this.state._DwollaSignUpForm
																					.employerStreet.placeholder
																		  )
																}
																margin={isMobile ? 'none' : 'normal'}
																name="employerStreet"
																onChange={this.handelInputChange}
																placeholder={isMobile ? 'Employer Street' : null}
																required
																value={
																	this.state._DwollaSignUpForm.employerStreet.value
																}
																variant="outlined"
															/>
														)}

														{(employmentStatus === 'EMP' || employmentStatus === 'CON') && (
															<Autocomplete
																style={{
																	backgroundColor:
																		this.props.forKYC &&
																		!this.state.isEnableEdit &&
																		'lightgrey'
																}}
																disabled={this.props.forKYC && !this.state.isEnableEdit}
																fullwidth
																getOptionLabel={option => option.label || ''}
																id="employerProvince"
																name="employerProvince"
																onChange={(event, value) =>
																	this.handleDropdownChange(
																		event,
																		value ? value.value : '',
																		'employerProvince'
																	)
																}
																options={this.state.provinces}
																popupIcon={<ExpandIcon />}
																renderInput={params => (
																	<TextField
																		disabled={
																			this.props.forKYC &&
																			!this.state.isEnableEdit
																		}
																		{...params}
																		autoComplete="off"
																		error={
																			!this.state._DwollaSignUpForm
																				.employerProvince.isValid &&
																			this.state._DwollaSignUpForm
																				.employerProvince.isTouched
																		}
																		label={
																			isMobile
																				? null
																				: t(
																						this.state._DwollaSignUpForm
																							.employerProvince
																							.placeholder
																				  )
																		}
																		name="region"
																		placeholder={
																			isMobile ? 'Employer Province' : null
																		}
																		variant="outlined"
																	/>
																)}
																value={{
																	label: this.state._DwollaSignUpForm.employerProvince
																		.value,
																	value: this.state._DwollaSignUpForm.employerProvince
																		.value
																}}
															/>
														)}

														{(employmentStatus === 'EMP' || employmentStatus === 'CON') && (
															<Autocomplete
																style={{
																	backgroundColor:
																		this.props.forKYC &&
																		!this.state.isEnableEdit &&
																		'lightgrey'
																}}
																disabled={this.props.forKYC && !this.state.isEnableEdit}
																fullwidth
																getOptionLabel={option => option.label || ''}
																id="employerCity"
																name="employerCity"
																onChange={(event, value) =>
																	this.handleDropdownChange(
																		event,
																		value ? value.value : '',
																		'employerCity'
																	)
																}
																options={this.state.cities}
																popupIcon={<ExpandIcon />}
																renderInput={params => (
																	<TextField
																		disabled={
																			this.props.forKYC &&
																			!this.state.isEnableEdit
																		}
																		{...params}
																		autoComplete="off"
																		error={
																			!this.state._DwollaSignUpForm.employerCity
																				.isValid &&
																			this.state._DwollaSignUpForm.employerCity
																				.isTouched
																		}
																		label={
																			isMobile
																				? null
																				: t(
																						this.state._DwollaSignUpForm
																							.employerCity.placeholder
																				  )
																		}
																		name="region"
																		placeholder={isMobile ? 'Employer City' : null}
																		variant="outlined"
																	/>
																)}
																value={{
																	label: this.state._DwollaSignUpForm.employerCity
																		.value,
																	value: this.state._DwollaSignUpForm.employerCity
																		.value
																}}
															/>
														)}

														{(employmentStatus === 'EMP' || employmentStatus === 'CON') && (
															<Autocomplete
																style={{
																	backgroundColor:
																		this.props.forKYC &&
																		!this.state.isEnableEdit &&
																		'lightgrey'
																}}
																disabled={this.props.forKYC && !this.state.isEnableEdit}
																fullwidth
																getOptionLabel={option => option.label || ''}
																id="employerBarangay"
																name="employerBarangay"
																onChange={(event, value) =>
																	this.handleDropdownChange(
																		event,
																		value ? value.value : '',
																		'employerBarangay'
																	)
																}
																options={this.state.barangays}
																popupIcon={<ExpandIcon />}
																renderInput={params => (
																	<TextField
																		{...params}
																		disabled={
																			this.props.forKYC &&
																			!this.state.isEnableEdit
																		}
																		autoComplete="off"
																		error={
																			!this.state._DwollaSignUpForm
																				.employerBarangay.isValid &&
																			this.state._DwollaSignUpForm
																				.employerBarangay.isTouched
																		}
																		label={
																			isMobile
																				? null
																				: t(
																						this.state._DwollaSignUpForm
																							.employerBarangay
																							.placeholder
																				  )
																		}
																		name="region"
																		placeholder={
																			isMobile ? 'Employer Barangay' : null
																		}
																		variant="outlined"
																	/>
																)}
																value={{
																	label: this.state._DwollaSignUpForm.employerBarangay
																		.value,
																	value: this.state._DwollaSignUpForm.employerBarangay
																		.value
																}}
															/>
														)}

														{(employmentStatus === 'EMP' || employmentStatus === 'CON') && (
															<TextField
																inputProps={{
																	style: {
																		backgroundColor:
																			this.props.forKYC &&
																			!this.state.isEnableEdit &&
																			'lightgrey'
																	}
																}}
																disabled={this.props.forKYC && !this.state.isEnableEdit}
																autoComplete="employerPostalCode"
																className={classes.displayFlex}
																error={
																	!this.state._DwollaSignUpForm.employerPostalCode
																		.isValid &&
																	this.state._DwollaSignUpForm.employerPostalCode
																		.isTouched
																}
																fullWidth
																helperText={
																	!this.state._DwollaSignUpForm.employerPostalCode
																		.isValid &&
																	this.state._DwollaSignUpForm.employerPostalCode
																		.isTouched
																		? t(
																				this.state._DwollaSignUpForm
																					.employerPostalCode.error_text
																		  )
																		: ''
																}
																id="employerPostalCode"
																label={
																	isMobile
																		? null
																		: t(
																				this.state._DwollaSignUpForm
																					.employerPostalCode.placeholder
																		  )
																}
																margin={isMobile ? 'none' : 'normal'}
																name="employerPostalCode"
																onChange={this.handelInputChange}
																placeholder={isMobile ? 'Employer Postal Code' : null}
																required
																value={
																	this.state._DwollaSignUpForm.employerPostalCode
																		.value
																}
																variant="outlined"
															/>
														)}

														<div className={classes.blockdiv}>
															<FormControlLabel
																className="text-left"
																control={
																	<Checkbox
																		checked={this.state._agreeTermsAndConditions}
																		color="primary"
																		name="TermsAndCondition"
																		onChange={this.handleTermsConditionChange}
																		size={isMobile ? 'small' : 'medium'}
																	/>
																}
																id="checkbox-top"
																label={
																	isMobile ? (
																		<div className="agree_terms">
																			{this.termsConditionsLabel()}
																		</div>
																	) : (
																		this.termsConditionsLabel()
																	)
																}
															/>
															<FormHelperText id="text-red">
																{t(this.state._errorTermsAndConditionNotChecked)}
															</FormHelperText>
														</div>

														<div className={classes.blockdiv}>
															<MobileFooter
																disabled={
																	this.state._isDwollaProcessing ||
																	!this.state._agreeTermsAndConditions
																}
																divider={false}
																hasNext
																htmlType="Submit"
																onClick={
																	this.props.forKYC
																		? () => {
																				this.setState({ isEnableEdit: true });
																				window.scrollTo({
																					top: 0,
																					behavior: 'smooth' // Optional: smooth scrolling effect
																				});
																		  }
																		: this.props.onBack
																}
																onSubmit={this.onSubmitHandler}
																textButtonBack={
																	this.props.forKYC ? 'Modify' : t('back_button')
																}
																textButtonContinue={
																	this.state._isDwollaProcessing ? null : 'SUBMIT'
																}
															/>
															{this.state._isDwollaProcessing ? (
																<CircularProgress disableShrink size={18} />
															) : isMobile ? null : (
																<ArrowForwardIcon />
															)}

															{isMobile ? null : (
																<>
																	<Fab
																		aria-label="add"
																		className={classes.submit}
																		color="primary"
																		onClick={
																			this.props.forKYC
																				? () => {
																						this.setState({
																							isEnableEdit: true
																						});
																						window.scrollTo({
																							top: 0,
																							behavior: 'smooth' // Optional: smooth scrolling effect
																						});
																				  }
																				: this.props.onBack
																		}
																		size="medium"
																		style={{
																			marginRight: '10px'
																		}}
																		type="submit"
																		variant="extended">
																		{this.props.forKYC
																			? 'Modify'
																			: t('back_button')}{' '}
																		&nbsp;
																	</Fab>
																	<Fab
																		aria-label="add"
																		className={classes.submit}
																		color="primary"
																		disabled={
																			this.state._isDwollaProcessing ||
																			!this.state._agreeTermsAndConditions
																		}
																		onClick={this.onSubmitHandler}
																		size="medium"
																		style={{
																			marginRight: '10px'
																		}}
																		type="submit"
																		variant="extended">
																		{t('agree_and_continue_button')} &nbsp;
																		{this.state._isDwollaProcessing ? (
																			<CircularProgress disableShrink size={18} />
																		) : (
																			<ArrowForwardIcon />
																		)}
																	</Fab>
																</>
															)}
														</div>
													</form>
												</div>
											</Paper>
										</Grid>
									</Grid>
								</Paper>
							</Container>
						);
					}}
				</IIFC>
			);
		}
	}
}

export default withStyles(styles)(withTranslation(['DwollaPlaid'])(index));
